export default function formCookie({main, on, elm}) {
    const cookiesDialog = elm.closest('dialog');

    main(() => {
        init();

        on('click', '[data-accept]', accept)
    });

    const init = function() {
        setTimeout(() => {
            cookiesDialog.show();
        });
    };

    const accept = async function() {
		const expires = new Date(
			Date.now() + 24 * 60 * 60 * 1000
		).toUTCString();

		document.cookie = [
			'policy=1',
			`expires=${expires}`,
			'path=/',
			'SameSite=Lax'
		].join('; ');

		cookiesDialog.close();
    };
};

export const model = {};
